export const GFN_EXCLUSION_LIST = [
  "ko-kr",
  "zh-tw",
  "zh-cn",
  "ro-ro",
  "ru-ru",
  "en-in",
  "en-sg",
  "en-au",
  "tr-tr",
  "fr-be",
  "es-la",
  "pt-br",
];
